
const digest = '4ab7d74025b1ae074623a66889410445f6806be74139cfd87592392a0780e334';
const classes = {"root":"_root_2jess_1","search":"_search_2jess_8","hint":"_hint_2jess_26","list":"_list_2jess_33","patient":"_patient_2jess_46","texts":"_texts_2jess_71","name":"_name_2jess_79","meta":"_meta_2jess_86","rid":"_rid_2jess_92","ridPaired":"_ridPaired_2jess_104","ridDanger":"_ridDanger_2jess_109","check":"_check_2jess_113","selected":"_selected_2jess_125"};
const css = `._root_2jess_1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: var(--md-font-family);
}

._search_2jess_8 [class*="Input-module_wrapper"] {
  min-height: 50px;
  padding: 0 20px;
  gap: 8px;
  border-radius: 24px;
}

._search_2jess_8 [class*="Input-module_prefix"] {
  display: flex;
  color: var(--md-color-label);
}

._search_2jess_8 [class*="Input-module_input"] {
  padding: 0;
  font-size: 14px;
  color: var(--md-color-label);
}

._hint_2jess_26 {
  margin: 0;
  font-size: 12px;
  line-height: 14px;
  color: var(--md-color-text-secondary);
}

._list_2jess_33 {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--md-color-border-light);
  border-radius: 8px;
}

._list_2jess_33 li + li {
  border-top: 1px solid var(--md-color-border-light);
}

._patient_2jess_46 {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 60px;
  padding: 12px 16px;
  border: 0;
  background: var(--md-white);
  text-align: left;
  cursor: pointer;
}
._patient_2jess_46:hover:not(:disabled) {
  background: #f7fafe;
}
._patient_2jess_46:focus {
  outline: none;
}
._patient_2jess_46:focus-visible {
  box-shadow: inset 0 0 0 2px var(--md-color-primary);
}
._patient_2jess_46:disabled {
  cursor: progress;
}

._texts_2jess_71 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-grow: 1;
  min-width: 0;
}

._name_2jess_79 {
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  color: var(--md-black);
}

._meta_2jess_86 {
  font-size: 12px;
  line-height: 14px;
  color: var(--md-color-text-secondary);
}

._rid_2jess_92 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  font-size: 12px;
  color: var(--md-color-text-secondary);
}
._rid_2jess_92 svg {
  color: var(--md-color-text-key);
}

._ridPaired_2jess_104,
._ridPaired_2jess_104 svg {
  color: var(--md-color-success);
}

._ridDanger_2jess_109 {
  color: var(--md-color-danger);
}

._check_2jess_113 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--md-color-primary);
  color: var(--md-white);
}

._selected_2jess_125,
._selected_2jess_125:hover:not(:disabled) {
  background: var(--md-color-primary-soft);
}
._selected_2jess_125 ._name_2jess_79,
._selected_2jess_125:hover:not(:disabled) ._name_2jess_79 {
  color: var(--md-color-primary-soft-text);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  